import React from "react";
import loadable from "@loadable/component";
import AppLayout from "@/layout";
import PageLayout from "@/layout/PageLayout";
import {
  GlobalOutlined,
  UserOutlined,
  HomeOutlined,
  ReconciliationOutlined,
  ShopOutlined,
  SettingOutlined,
  CustomerServiceOutlined,
  ContactsOutlined,
  MoneyCollectOutlined,
  ProductOutlined
} from "@ant-design/icons";

const routes = [
  {
    path: "/",
    element: AppLayout,
    redirect: "",
    name: "系统",
    icon: <GlobalOutlined />,
    auth: false,
    hidden: false,
    routes: [
      {
        path: "/workspace",
        element: PageLayout,
        redirect: "/workspace/dashboard",
        name: "首页",
        icon: <HomeOutlined />,
        auth: true,
        hidden: false,
        routes: [
          // {
          //   path: "/workspace/workbench",
          //   element: loadable(() => import("@/views/Workspace/Workbench")),
          //   name: "工作台",
          //   icon: null,
          //   auth: true,
          //   hidden: false,
          //   routes: [],
          // },
          {
            path: "/workspace/dashboard",
            element: loadable(() => import("@/views/Workspace/Dashboard")),
            name: "数据看板",
            isCache: true,
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/refurbish",
        element: PageLayout,
        redirect: "/refurbish/list",
        name: "整备管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/refurbish/list",
            element: loadable(() => import("@/views/Refurbish/List")),
            name: "整备列表",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/customer",
        element: PageLayout,
        redirect: "/customer/list",
        name: "会员管理",
        icon: <UserOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/customer/list",
            element: loadable(() => import("@/views/Customer/List")),
            name: "会员列表",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/customer/form/:id",
            element: loadable(() => import("@/views/Customer/List/Form")),
            name: "会员信息",
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/customer/order/list",
            element: loadable(() => import("@/views/Customer/Order/List")),
            name: "会员订单",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/customer/blackList",
            element: loadable(() => import("@/views/Customer/BlackList")),
            name: "黑名单列表",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/market",
        element: PageLayout,
        redirect: "/market/brand/list",
        name: "集市管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/market/brand/list",
            element: loadable(() => import("@/views/Market/Brand/List")),
            name: "品牌管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/majorclass/list",
            element: loadable(() => import("@/views/Market/MajorClass/List")),
            name: "大类管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/subclass/list",
            element: loadable(() => import("@/views/Market/SubClass/List")),
            name: "小类管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/product/prodService",
            element: loadable(() => import("@/views/Market/ProdService/List")),
            name: "产品服务",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/product/list",
            element: loadable(() => import("@/views/Market/Product/List")),
            name: "产品管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/product/item/:id?",
            element: loadable(() => import("@/views/Market/Product/Form")),
            name: "产品信息",
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/goods/list",
            element: loadable(() => import("@/views/Market/Goods/List")),
            name: "基础商品管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/order/list",
            element: loadable(() => import("@/views/Market/Order/List")),
            name: "集市订单",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/market/order/item/:id?",
            element: loadable(() => import("@/views/Market/Order/Item")),
            name: "集市订单详情",
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/purchase",
        element: PageLayout,
        redirect: "/purchase/list",
        name: "采购管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/purchase/list",
            element: loadable(() => import("@/views/Purchase/List")),
            name: "采购管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/inventory",
        element: PageLayout,
        redirect: "/inventory/list",
        name: "库存管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/inventory/list",
            element: loadable(() => import("@/views/Inventory/List")),
            name: "库存管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/recycle",
        element: PageLayout,
        redirect: "/recycle/list",
        name: "回收管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/recycle/list",
            element: loadable(() => import("@/views/Recycle/List")),
            name: "回收管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/recycle/add",
            element: loadable(() => import("@/views/Recycle/Form")),
            name: "回收录入",
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/recycle/edit/:id",
            element: loadable(() => import("@/views/Recycle/Form")),
            name: "回收编辑",
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/recycle/detail/:id",
            element: loadable(() => import("@/views/Recycle/Form")),
            name: "回收详情",
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/recycle/promise/list",
            element: loadable(() => import("@/views/Promise/List")),
            name: "回收承诺",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/aftersale",
        element: PageLayout,
        redirect: "/aftersale/list",
        name: "售后管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/aftersale/list",
            element: loadable(() => import("@/views/AfterSale/List")),
            name: "售后管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/demand",
        element: PageLayout,
        redirect: "/demand/list",
        name: "需求管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/demand/list",
            element: loadable(() => import("@/views/Demand/List")),
            name: "用户需求",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/qualityAssurance",
        element: PageLayout,
        redirect: "/qualityAssurance/list",
        name: "质保管理",
        icon: <ReconciliationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/qualityAssurance/list",
            element: loadable(() => import("@/views/QualityAssurance/List")),
            name: "质保配置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/activity",
        element: PageLayout,
        redirect: "/activity/class/list",
        name: "活动管理",
        icon: <ContactsOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/activity/class/list",
            element: loadable(() => import("@/views/Activity/Class/List")),
            name: "活动分类",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/activity/leader/list",
            element: loadable(() => import("@/views/Activity/Leader/List")),
            name: "活动主理人",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/activity/list",
            element: loadable(() => import("@/views/Activity/List")),
            name: "活动列表",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/activity/form/:id",
            element: loadable(() => import("@/views/Activity/List/Form")),
            name: "活动信息",
            icon: null,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/activity/order/list",
            element: loadable(() => import("@/views/Activity/Order/List")),
            name: "活动订单",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/activity/order/item/:id",
            element: loadable(() => import("@/views/Activity/Order/Item")),
            name: "订单详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: []
          }
          // {
          //   path: "/activity/aftersale/list",
          //   element: loadable(() => import("@/views/Activity/AfterSale/List")),
          //   name: "活动售后",
          //   icon: null,
          //   auth: true,
          //   hidden: true,
          //   routes: [],
          // },
          // {
          //   path: "/activity/aftersale/item/:id",
          //   element: loadable(() => import("@/views/Activity/AfterSale/Item")),
          //   name: "售后详情",
          //   icon: null,
          //   auth: true,
          //   hidden: true,
          //   routes: [],
          // },
        ]
      },
      {
        path: "/finance",
        element: PageLayout,
        redirect: "/finance/cashout/list",
        name: "财务管理",
        icon: <MoneyCollectOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/finance/cashout/list",
            element: loadable(() => import("@/views/Finance/Cashout/List")),
            name: "提现申请",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "reconciliation/list",
            element: loadable(
              () => import("@/views/Finance/Reconciliation/List")
            ),
            name: "对账管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/saling",
        element: PageLayout,
        redirect: "/saling/banner/list",
        name: "营销管理",
        icon: <ShopOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/saling/banner/list",
            element: loadable(() => import("@/views/Saling/Banner/List")),
            name: "轮播图配置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/saling/ad/list",
            element: loadable(() => import("@/views/Saling/Ad/List")),
            name: "广告位配置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/saling/product/list",
            element: loadable(() => import("@/views/Saling/Product/List")),
            name: "推荐产品",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/saling/coupon/list",
            element: loadable(() => import("@/views/Saling/Coupon/List")),
            name: "优惠券管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/saling/share",
            element: loadable(() => import("@/views/Saling/Share/Item")),
            name: "分享配置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/qa",
        element: PageLayout,
        redirect: "/qa/qaclass/list",
        name: "客服设置",
        icon: <CustomerServiceOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/qa/qaclass/list",
            element: loadable(() => import("@/views/Q&A/QAClass/List")),
            name: "QA分类",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/qa/qalist/list",
            element: loadable(() => import("@/views/Q&A/QAList/List")),
            name: "QA明细",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/qa/feedback/list",
            element: loadable(() => import("@/views/Q&A/Feedback/List")),
            name: "意见反馈",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/promotion",
        element: PageLayout,
        redirect: "/promotion/list",
        name: "推广管理",
        icon: <SettingOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/promotion/list",
            element: loadable(() => import("@/views/Promotion/List/List")),
            name: "推广明细",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/promotion/order",
            element: loadable(() => import("@/views/Promotion/Order/List")),
            name: "推广订单",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      },
      {
        path: "/settings",
        element: PageLayout,
        redirect: "/settings/admin/list",
        name: "系统设置",
        icon: <SettingOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/settings/role/list",
            element: loadable(() => import("@/views/Settings/Role/List")),
            name: "角色设置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/settings/admin/list",
            element: loadable(() => import("@/views/Settings/Admin/List")),
            name: "账号设置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/settings/menu/list",
            element: loadable(() => import("@/views/Settings/Menu/List")),
            name: "菜单管理",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/settings/rights/list",
            element: loadable(() => import("@/views/Settings/Rights/List")),
            name: "身份权益设置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/settings/freight/list",
            element: loadable(() => import("@/views/Settings/Freight/List")),
            name: "运费设置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/settings/pay/list",
            element: loadable(() => import("@/views/Settings/Pay/List")),
            name: "支付设置",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/settings/syslog/list",
            element: loadable(() => import("@/views/Settings/SysLog/List")),
            name: "系统日志",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          },
          {
            path: "/settings/upload/test",
            element: loadable(() => import("@/views/Settings/UploadTest/List")),
            name: "测试上传",
            icon: null,
            isCache: true,
            auth: true,
            hidden: false,
            routes: []
          }
        ]
      }
    ]
  },
  {
    path: "/login",
    element: loadable(() => import("@/views/Login/Login")),
    name: "登录",
    icon: null,
    auth: false,
    hidden: false,
    routes: []
  },
  {
    path: "/error",
    element: loadable(() => import("@/components/500")),
    name: "500 服务器发生错误",
    hidden: false,
    routes: []
  },
  {
    path: "/forbidden",
    element: loadable(() => import("@/components/403")),
    name: "403 禁止访问",
    hidden: false,
    routes: []
  },
  {
    path: "*",
    element: loadable(() => import("@/components/404")),
    name: "404 页面未找到",
    hidden: false,
    routes: []
  }
];

export default routes;
